import React, { useState } from "react";
import { SearchFormContainer } from "../../styled/shop";
import { GoChevronRight } from "react-icons/go";

const ShopSearchForm = ({ searched, setSearched, searchProducts }) => {
  return (
    <SearchFormContainer>
      <div className="inputField">
        <input
          type="text"
          placeholder="구매 상품 검색하기"
          value={searched}
          onChange={(e) => setSearched(e.target.value)}
        />
        <button onClick={searchProducts}>
          <GoChevronRight />
        </button>
      </div>
    </SearchFormContainer>
  );
};

export default ShopSearchForm;
